import { render, staticRenderFns } from "./AppScroll.vue?vue&type=template&id=37b918d4&"
import script from "./AppScroll.vue?vue&type=script&lang=js&"
export * from "./AppScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports